<crnt-form-control>
  <rfa-errors slot="validation" [control]="control"></rfa-errors>
</crnt-form-control>

<crnt-checkbox [state]="control.hasError() ? 'invalid' : 'enabled'">
  <label
    slot="label"
    [wlAutomationId]="control.options.dataAutomationId"
    [for]="control.id"
  >
    {{ control.options.label }}
  </label>
  <input
    type="checkbox"
    [id]="control.id"
    [formControl]="control"
    [wlTrackValueChange]="valueChangeTrackConfig()"
    [attr.aria-describedby]="ariaDescribedBy()"
  />
  @if (control.options.helpText) {
    <div slot="help">
      {{ control.options.helpText }}
    </div>
  }
</crnt-checkbox>
